

export class SelectedPortInput implements ISelectedPortInput {
    /** The auto-generated id of the device model port specification master */
    deviceModelPortSpecificationId!: number;
    /** The auto-generated id of the device model port allocation master */
    deviceModelPortAllocationId!: number;
    /** The reading type should be "Direct" or "Inverse" */
    readingType!: string;
    /** The work hour calculation should be 1 or 0 */
    workHourCalculation!: number;

    constructor(data?: ISelectedPortInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceModelPortSpecificationId = _data["deviceModelPortSpecificationId"];
            this.deviceModelPortAllocationId = _data["deviceModelPortAllocationId"];
            this.readingType = _data["readingType"];
            this.workHourCalculation = _data["workHourCalculation"];
        }
    }

    static fromJS(data: any): SelectedPortInput {
        data = typeof data === 'object' ? data : {};
        let result = new SelectedPortInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceModelPortSpecificationId"] = this.deviceModelPortSpecificationId;
        data["deviceModelPortAllocationId"] = this.deviceModelPortAllocationId;
        data["readingType"] = this.readingType;
        data["workHourCalculation"] = this.workHourCalculation;
        return data; 
    }
}

export interface ISelectedPortInput {
    /** The auto-generated id of the device model port specification master */
    deviceModelPortSpecificationId: number;
    /** The auto-generated id of the device model port allocation master */
    deviceModelPortAllocationId: number;
    /** The reading type should be "Direct" or "Inverse" */
    readingType: string;
    /** The work hour calculation should be 1 or 0 */
    workHourCalculation: number;
}

